/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Params} from '@angular/router';

export function at(obj: Object, path: string) {
  const properties = path.split('.');
  return properties.reduce((aggregate, property) => aggregate && aggregate[property], obj);
}

export const filtersAreDifferent = (filtersValue: { [key: string]: string }, queryParams: Params) => {
  return Object.keys(filtersValue).filter((key) => {
    return queryParams[key] && filtersValue[key] !== queryParams[key];
  }).length > 0;
};


export const buildFiltersQuery = (filterValues: {
  [key: string]: string
}) => Object.keys(filterValues).reduce((prev, key) => {
  const value = filterValues[key].trim();
  if (value) {
    const prefix = prev === '' ? '' : `;`;
    prev += `${prefix}${key}==${value}`;
  }
  return prev;
}, '');

export const buildQueryParams = (filterValues: { [key: string]: string }) => {
  return Object.keys(filterValues)
    .reduce((obj: { [key: string]: string }, key: string) => {
      if (filterValues[key] !== '') {
        obj[key] = filterValues[key];
      }
      return obj;
    }, {});
};

/**
 * Enums utilities
 */
export class Objects {
  public static removeSpaces(obj: any) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && typeof obj[key] === 'string') {
        obj[key] = obj[key].replace(/\s+/g, ' ').trim();
      } else if (typeof obj[key] === 'object') {
        Objects.removeSpaces(obj[key]);
      }
    }
  }
}
